<div class="header-section">
    <div class="header">{{ cbmLabelContent.header }}</div>
    <div class="description">
        <cms-text [broadbandHeaderLink]="true" [originalText]="cbmLabelContent.description"></cms-text>
        <div class ="notification-banner" *ngIf="isGrandFatheredLabel">
            <xm-media-image [imageOptions]="infoIconGrey" size="width" center="vert" class="icon"></xm-media-image>
            <cms-text class="grandfather-text" [broadbandHeaderLink]="true" [originalText]="cbmLabelContent.noLabel"></cms-text>
        </div>
    </div>
</div>
